import { render, staticRenderFns } from "./ProjectType.vue?vue&type=template&id=64a578f4"
import script from "./ProjectType.vue?vue&type=script&lang=js"
export * from "./ProjectType.vue?vue&type=script&lang=js"
import style0 from "./ProjectType.vue?vue&type=style&index=0&id=64a578f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports